import { useQuery } from '@apollo/client';

import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import useLearnerObjectLearningGoalData from 'bundles/onboarding-common/hooks/useLearnerObjectLearningGoalData';
import LearnerProfileLearningGoalQuery from 'bundles/onboarding-common/queries/LearnerProfileLearningGoal.graphql';
import type {
  LearnerProfileLearningGoalQueryQuery,
  LearnerProfileLearningGoalQueryQueryVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerProfileLearningGoal';
import { getShouldMigrateToLearnerObject } from 'bundles/onboarding-common/utils/experimentUtils';
import { formatLearningGoalFromLearnerProfile } from 'bundles/onboarding-common/utils/savedQuestionDataUtils';

const useLearningGoalData = ({ skip }: { skip?: boolean }) => {
  const shouldMigrateToLearnerObject = getShouldMigrateToLearnerObject();

  // Use LearnerObject query if epic is enabled
  const learnerObjectResult = useLearnerObjectLearningGoalData({
    skip: skip || !shouldMigrateToLearnerObject,
  });

  // Use LearnerProfile query as fallback
  const { data, loading } = useQuery<
    LearnerProfileLearningGoalQueryQuery,
    LearnerProfileLearningGoalQueryQueryVariables
  >(LearnerProfileLearningGoalQuery, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
    skip: skip || shouldMigrateToLearnerObject,
  });

  // Return LearnerObject result if epic is enabled
  if (shouldMigrateToLearnerObject) {
    return learnerObjectResult;
  }

  // Return LearnerProfile result as fallback
  return {
    value: formatLearningGoalFromLearnerProfile(data),
    loading,
    __typename: QUESTION_IDS.learningGoal,
  };
};

export default useLearningGoalData;
